<template>
  <div :class="'categories categories--' + $store.getters['auth/role']">
    <div
      :class="
        'swiper-container swiper--product-families swiper-container--' + $store.getters['auth/role']
      "
    >
      <div class="swiper-wrapper">
        <!-- Slides -->
        <router-link
          :to="{ name: 'ProductListCat', params: { cat: item.id, catname: item.name } }"
          class="swiper-slide"
          v-for="item in items"
          :item="item"
          :itemName="item.name"
          :key="item.id"
        >
          {{ item.name }}
        </router-link>
        <!-- <div class="swiper-slide" v-for="item in items" :item="item">{{ item.name }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { languages_trad } from "@/traductions/config";
import { defaultLocale } from "@/traductions/config";

export default {
  name: "ProductFamilyList",
  data() {
    return {
      locale: this.$i18n.locale,
      languages: languages_trad,
      links: {
        // Always displayed
      },
    };
  },
  mounted() {
    const self = this;

    this.$store.dispatch("productfamily/getAll").then(() => {
      if (this.$store.getters["auth/isRole"]("ROLE_AGENT") == true) {
        const swiper = new Swiper(".swiper--product-families", {
          slidesPerView: 5,
        });
      } else if (this.$store.getters["auth/isRole"]("ROLE_TECHNICIAN") == true) {
        const swiper = new Swiper(".swiper--product-families", {
          slidesPerView: 3,
        });
      }
    });
  },
  computed: {
    items: function () {
      let items = this.$store.getters["productfamily/getAll"];

      if (items) {
        this.totalRows = items.length;
        return items;
      }
    },
  },
  watch: {
    locale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("defaultLocale", lang);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "/static/swiper/css/swiper.min.css";
@import "~@/assets/scss/_colors.scss";

.categories {
  width: 75%;
  position: fixed;
  background-color: white;
  z-index: 10;
  top: 135px;
  border-bottom: 1px solid $grisclair; //box-shadow: 0 6px 4px -4px $grisclair;
  &--ROLE_TECHNICIAN {
    width: 100%;
    position: relative;
    top: auto;
    &.categories--stock,
    &.categories--reappro {
      .swiper-container--tech {
        margin-top: 0;
      }
    }
  }
}

.swiper-slide {
  width: calc(100% / 5) !important;
  text-align: center;
  display: inline-block;
  color: $mystockblue;
  font-family: "ClanPro";
  font-size: 12px;
  border-left: 1px solid $color2;
  line-height: 40px;
  &:first-of-type {
    border-left: none;
  }
  &:hover {
    text-decoration: none;
  }
  &.router-link-exact-active {
    color: $color2;
    font-family: "ClanProBold";
  }
}
.swiper-container {
  height: 80px;
  line-height: 80px;
  width: 100%;
  padding: 20px 0;
  &--ROLE_TECHNICIAN {
    height: 65px;
    line-height: 65px;
    padding: 15px 0;
    margin-top: 20px;
    .swiper-slide {
      width: calc(100% / 3) !important;
    }
  }
}

@media screen and (max-width: 1680px) {
  .categories {
    width: calc(100% - 415px);
    right: 415px;
  }
}

@media screen and (max-width: 1450px) {
  .categories {
    &--ROLE_TECHNICIAN {
      width: 100%;
      position: relative;
      top: auto;
      right: auto;
    }
  }
}

@media screen and (max-width: 500px) {
  .swiper-container {
    height: 80px;
    line-height: 80px;
    width: 100%;
    padding: 20px 0;
    &--ROLE_TECHNICIAN {
      height: 65px;
      line-height: 65px;
      padding: 15px 0;
      margin-top: 20px;
      .swiper-slide {
        width: calc(100% / 3) !important;
        line-height: 1;
        padding: 0 15px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductFamily/ProductFamilyList.vue